import { Button, CheckBox, Form, NumberBox, Popup, SelectBox, TabPanel, TextArea, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, Label, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import DataGateProps from './DataGateProps';

const components = [ ///////////////////////////////
    'NumberBox',
    'TextBox',
    'TextArea',
    'DateBox',
    'DatePicker',
    'TimePicker',
    'CheckBox',
    'Switch',
    'SelectBox',
    'Button'
];

class FormFieldProps extends Component {
    state = {
        field: this.props.field ?? {}
    }

    set = updater => {
        updater(this.state.field);
        this.forceUpdate();
    }

    render() {
        return (
            <>
                <Form rtlEnabled colCount={60} width='50rem' height='auto'>
                    <SimpleItem colSpan={30}  >
                        <Label text='توضیح' />
                        <TextBox rtlEnabled value={this.state.field.dsc} onValueChanged={e => this.set(f => f.dsc = e.value)}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={30}>
                        <Label text='راهنمایی' />
                        <TextBox rtlEnabled value={this.state.field.hint} onValueChanged={e => this.set(f => f.hint = e.value)}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={30}>
                        <Label text='مقدار پیشفرض' />
                        <TextBox rtlEnabled value={this.state.field.defaultValue} onValueChanged={e => this.set(f => f.defaultValue = e.value)}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={30}>
                        <Label text='عنوان فارسی' />
                        <TextBox rtlEnabled value={this.state.field.caption_FA} onValueChanged={e => this.set(f => f.caption_FA = e.value)}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={30}>
                        <Label text='عنوان انگلیسی' />
                        <TextBox rtlEnabled={false} className='mdh-left-align'
                            value={this.state.field.caption_EN} onValueChanged={e => this.set(f => f.caption_EN = e.value)}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={30}>
                        <Label text='عنوان عربی' />
                        <TextBox rtlEnabled value={this.state.field.caption_AR} onValueChanged={e => this.set(f => f.caption_AR = e.value)}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={30}>
                        <Label text='دروازه داده' />
                        <Button text='انتخاب . . .' onClick={() => this.setState({ dataGatePopVisible: true })} width='100%'
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={30}>
                        <Label text='فقط خواندنی' />
                        <CheckBox rtlEnabled value={this.state.field.isReadOnly === true} onValueChanged={e => this.set(f => f.isReadOnly = e.value === true)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <Label text='گزینه ها' />
                        <Button text='انتخاب . . .' onClick={() => this.setState({ lookupPopVisible: true })} width='100%' />
                    </SimpleItem>

                    <SimpleItem colSpan={30} rtlEnabled={false}>
                        <Label text='کمپوننت' />
                        <SelectBox dataSource={components} rtlEnabled={false} className='mdh-left-align'
                            value={this.state.field.component} onValueChanged={e => this.set(f => f.component = e.value)}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={60}>
                        <Label text='خصوصیات کمپوننت' />
                        <TextArea rtlEnabled={false} className='mdh-left-align'
                            // placeholder='Write a javascript or json object, containing custom properties. By default it is {}'
                            value={this.state.field.componentProps} onValueChanged={e => this.set(f => f.componentProps = e.value)}
                        />
                    </SimpleItem>

                    <EmptyItem colSpan={30} />

                    <ButtonItem colSpan={15} buttonOptions={{
                        text: 'قبول', icon: 'check', width: '90%', type: 'success',
                        onClick: () => this.props.onOk(this.state.field)
                    }}
                    />

                    <ButtonItem colSpan={15} buttonOptions={{
                        text: 'رد', icon: 'close', width: '90%', type: 'danger',
                        onClick: () => this.props.onCancel()
                    }} />
                </Form >
                {/* 
                <Popup title='دروازه داده' visible={this.state.dataGatePopVisible} showCloseButton rtlEnabled
                    width='auto' height='auto'
                    onHidden={() => this.setState({ dataGatePopVisible: false })}
                >
                    <DataGateProps dataGate={JSON.parse(this.state.field?.rowDataGateJsn ?? '{}')}
                        acceptableTypes={[3]}
                        onOk={dataGate => {
                            this.setState({
                                field: { ...this.state.field, rowDataGateJsn: JSON.stringify(dataGate) },
                                dataGatePopVisible: false
                            });
                        }}
                        onCancel={() => this.setState({ dataGatePopVisible: false })}
                    />
                </Popup> 
                */}

                <Popup title='دروازه داده' visible={this.state.dataGatePopVisible} showCloseButton rtlEnabled
                    width='auto' height='auto'
                    onHidden={() => this.setState({ dataGatePopVisible: false })}
                >
                    <DataGateProps dataGate={JSON.parse(this.state.field?.rowDataGateJsn ?? '{}')}
                        onOk={dataGate => {
                            this.setState({
                                field: { ...this.state.field, rowDataGateJsn: JSON.stringify(dataGate) },
                                dataGatePopVisible: false
                            });
                        }}
                        onCancel={() => this.setState({ dataGatePopVisible: false })}
                    />
                </Popup>

                <Popup title='گزینه ها' visible={this.state.lookupPopVisible} showCloseButton rtlEnabled
                    width='auto' height='auto'
                    onHidden={() => this.setState({ lookupPopVisible: false })}
                >
                    <DataGateProps dataGate={JSON.parse(this.state.field?.lookupJsn ?? '{}')}
                        hideJsMapping
                        //acceptableTypes={[3]}
                        onOk={dataGate => {
                            this.setState({
                                field: { ...this.state.field, lookupJsn: JSON.stringify(dataGate) },
                                lookupPopVisible: false
                            });
                        }}
                        onCancel={() => this.setState({ lookupPopVisible: false })}
                    />
                </Popup>
            </>
        );
    }
}

export default FormFieldProps;